'use strict';

const { conditionIsGo, buildConditionItem, collectConditionFieldIds } = require('./conditionIsGo');

var ctrl = ['$state', '$scope', function ($state, $scope) {
    var _this = this;
    // Init model
     this.model[this.field.id] = this.model[this.field.id] || {
        type: this.field.type,
        id: this.field.id,
        value: undefined,valid:true,
    } 


    // Al desactivarse un grupo hay que resetear en el modelo los valores de sus nodos, de lo contrario
    // las fórmulas ocultas que leen el payload por id siguen usando datos del grupo oculto y permiten validar sin completarlo.
    this.clearNodesValue = (nodes) => {
        (nodes || []).forEach((node) => {
            if (node.type === 'group' && node.nodes) {
                _this.clearNodesValue(node.nodes);
            } else if (_this.model && _this.model.hasOwnProperty(node.id)) {
                const entry = _this.model[node.id];
                entry.value = Array.isArray(entry.value) ? [] : undefined;
                entry.valid = true;
            }
        });
    }

    // "item" con .payload que espera conditionIsGo: payload del registro original + payload de validación + modelo local.
    this.buildConditionItem = () => {
        const base = (_this.item && _this.item.payload) ? _this.item.payload : {};
        return buildConditionItem(base, _this.completeModel, _this.model);
    }

    // Valor de un requisito simple (requires), buscándolo en el modelo local, el completo o el payload original.
    this.getRequireValue = (elementId) => {
        if (_this.model && _this.model.hasOwnProperty(elementId))
            return _this.model[elementId] ? _this.model[elementId].value : undefined;
        if (_this.completeModel && _this.completeModel.hasOwnProperty(elementId))
            return _this.completeModel[elementId] ? _this.completeModel[elementId].value : undefined;
        if (_this.item && _this.item.payload && _this.item.payload.hasOwnProperty(elementId))
            return _this.item.payload[elementId] ? _this.item.payload[elementId].value : undefined;
        return undefined;
    }

    // Misma lógica que GroupElement.tsx: el grupo se muestra si se cumplen los requires (todos) o se dispara el dynamicRequires.
    this.activeGroup = () => {
        const field = _this.field;
        const wasActive = field.inactiveGroup === false;
        const requires = field.requires || [];
        const dynamicRequires = field.dynamicRequires || [];
        const item = _this.buildConditionItem();

        let missingCondition = false;
        if (requires.length > 0 && dynamicRequires.length > 0) {
            dynamicRequires[0].options = true;
            missingCondition = requires.some((requisite) => _this.getRequireValue(requisite.elementId) !== requisite.expectedValue)
                && !(conditionIsGo(dynamicRequires, item)[0] === true);
        } else if (requires.length > 0) {
            missingCondition = requires.some((requisite) => _this.getRequireValue(requisite.elementId) !== requisite.expectedValue);
        } else if (dynamicRequires.length > 0) {
            dynamicRequires[0].options = true;
            missingCondition = !(conditionIsGo(dynamicRequires, item)[0] === true);
        }

        field.inactiveGroup = missingCondition;
        if (field.inactiveGroup && wasActive) {
            _this.clearNodesValue(field.nodes);
        }
    }

    // Se observan tanto los requires como los campos referenciados en dynamicRequires para reevaluar el grupo al cambiar.
    const idsToWatch = (_this.field.requires || []).map((r) => r.elementId);
    collectConditionFieldIds(_this.field.dynamicRequires, idsToWatch);

    idsToWatch.forEach((fieldId) => {
        // Notación de corchetes con la clave entre comillas: los ids pueden empezar con dígito (ej. "3el1440fp")
        // y `ctrl.model.3el1440fp.value` rompe el parser de Angular ($parse:syntax). Con ["<id>"] funciona igual.
        let elementToWatch;
        if (_this.model.hasOwnProperty(fieldId))
            elementToWatch = `ctrl.model['${fieldId}'].value`;
        else if (_this.completeModel && _this.completeModel.hasOwnProperty(fieldId))
            elementToWatch = `ctrl.completeModel['${fieldId}'].value`;
        if (!elementToWatch)
            return;
        $scope.$watch(elementToWatch, function (newValue, oldValue) {
            if (newValue === oldValue)
                return;
            _this.activeGroup()
        }, true);
    })
    _this.activeGroup()

}];

module.exports = function () {
    return {
        restrict: 'E',
        scope: {
            field: '=',
            model: '=',
            item: '=',
            completeModel: '='
        },
        controller: ctrl,
        controllerAs: 'ctrl',
        bindToController: true,
        templateUrl: 'directives/groupElementDirective.html'
    };
};
